export const genericConstants = {
  ADD_IDENTIFICATION_DATA_SUCCESS: 'ADD_IDENTIFICATION_DATA_SUCCESS',
  
  ADD_TITLE_LEGO_CURRENT_SUCCESS: 'ADD_TITLE_LEGO_CURRENT_SUCCESS',
  SET_DEFAULT_LANGUAGE: 'SET_DEFAULT_LANGUAGE',
}
